module.exports = __webpack_public_path__ + "img/icon-warning-polartlavtrykk-4.11979e74.svg";